// extracted by mini-css-extract-plugin
export default {"LocSubscribersField":"c6yrTrcokL3PMSlZmYsBSVqBDeeIN74kOqYFWDWxxMH","addRow":"_17SJmzv7mpXNzm6nG32a7u7Xi87wlaFf73rNMXE6hga"};